import { render, staticRenderFns } from "./RsaConfigurazioneTipoPrestazioniListPage.vue?vue&type=template&id=5e0f26a5"
import script from "./RsaConfigurazioneTipoPrestazioniListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTipoPrestazioniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports